<div class="header">
    <div class="container">
        <div class="wrap">
            <a href="/" class="logo-link" aria-label="Parking Service Logo" title="Parking Service Logo">
                <img src="../assets/images/parking-logo.svg" title="logo" alt="logo" class="logo" />
            </a>
            <div class="buttons-right">
                <a  *ngIf="!isLogged" class="top-link" href="/fines" style="display: block;text-align: center;" [appTranslate]="'PAY_WITH_CARD'"></a>
                <button *ngIf="!!isLogged" [appTranslate]="'APPLY_FOR_LICENSE'" type="button" class="btn btn-primary"
                    aria-label="Apply for license"
                    (click)="apply()"></button>
                <div class="menu-dropdown" *ngIf="!!isLogged">
                    <button *ngIf="!isAdmin" class="btn-user" (click)="goToUserDetails()" aria-label="Open user profile">
                        <!-- <mat-icon aria-hidden="false" fontIcon="perm_identity"></mat-icon> -->
                        <img src="/assets/images/user-logged.svg" alt="" aria-hidden="true">
                    </button>
                    <button class="btn-user" mat-button [matMenuTriggerFor]="menu" aria-label="Open account menu">
                        <!-- <mat-icon aria-hidden="false" style="transform: rotate(180deg);" fontIcon="subject"></mat-icon> -->
                        <img src="/assets/images/menu.svg" alt="" aria-hidden="true">
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item class="logout-menu-btn" (click)="logout()">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <polyline points="16 17 21 12 16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span [appTranslate]="'LOGOUT'"></span>
                        </button>
                    </mat-menu>
                </div>
                <select id="header-language" name="headerLanguage" class="lng-select" (ngModelChange)="changeLanguage($event)" [(ngModel)]="selectedLanguage">
                    <option [value]="itm.Code" *ngFor="let itm of availableLanguages">
                        {{itm.Value}}
                    </option>
                </select>
                <button class="btn-user btn-menu" type="button" (click)="isMenuOpen = !isMenuOpen"
                    aria-label="Toggle navigation menu"
                    [class.open]="isMenuOpen" *ngIf="!!isLogged">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M22.5 12H1.5" stroke="#04101B" stroke-width="2.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M22.5 21H1.5" stroke="#04101B" stroke-width="2.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M22.5 3H7.5" stroke="#04101B" stroke-width="2.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <!-- <div *ngIf="!!isLogged">
            <div class="wrap-buttons">
                <button type="button" class="user" (click)="goToUserDetails()"><img
                        src="/Content/images/user.png" /></button>

                <button type="button" class="logout" (click)="logout()">
                    <span></span> <img src="/Content/images/logout.png" />
                </button>
            </div>
            <select id="legacy-language" name="legacyLanguage" class="language" (ngModelChange)="changeLanguage($event)" [(ngModel)]="selectedLanguage">
                <option [value]="itm.Code" *ngFor="let itm of availableLanguages">
                    {{itm.Value}}
                </option>
            </select>
        </div> -->

        </div>
    </div>
</div>


<div class="application-wrap">
    <div class="container">
        <div class="applicationDiv">
            <div class="sideStepper" *ngIf="isLogged" [class.is-open]="isMenuOpen">
                <app-nav (closeNav)="isMenuOpen = false"></app-nav>
            </div>

            <div class="menu-backdrop" *ngIf="isLogged && isMenuOpen" (click)="isMenuOpen = false"></div>

            <div class="mainView" [class.logged-in]="isLogged" [class.change-password]="isChangePassword">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>